import axios from './axiosConfig';

export const getActivityLogs = async (filters = {}) => {
  const params = {};
  if (filters.from) params.from = filters.from;
  if (filters.to) params.to = filters.to;
  if (filters.action) params.action = filters.action;
  if (filters.entity) params.entity = filters.entity;
  if (filters.user_id) params.user_id = filters.user_id;
  const response = await axios.get('/api/activity-log', { params });
  return response.data;
}; 